/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { useEffect, useContext } from 'react';
import { connect, Provider } from 'react-redux';
import ReactDOM from 'react-dom';

import { clearView, setView, hideAlert } from 'actions/viewActions';
import { getFrameWindow } from 'helpers/iframeHelpers';
import LocaleContext, { LS } from 'constants/localization';
import store from 'reducers/store';

import View from './View';
import Alert from 'components/common/CustomAlert';

const ViewContainer = ({ view, clearView, setView,
  alert, hideAlert, modalOpen }) => {
  const LS = useContext(LocaleContext);

  useEffect(() => {
    MetadataView.setView = props => {
      updateLocale(props.locale);
      // Add unload listener to clear view when iframe is reloaded
      getFrameWindow().addEventListener('pagehide', () => {
        clearView();
        hideAlert();
      });
      setView(props);
    };
    MetadataView.embed = (id, frame, props) => {
      if (!frame) {
        frame = window;
      }
      updateLocale(props.locale);
      const container = frame.document.querySelector(`#${id}`);
      ReactDOM.render(
        <Provider store={store}>
          <LocaleContext.Provider value={LS}>
            <View {...props} />
          </LocaleContext.Provider>
        </Provider>, container);
    };
    window.dispatchEvent(new Event('react-load'));
  }, []);

  return (
    <LocaleContext.Provider value={LS}>
      { !modalOpen && <Alert alert={alert} onClose={hideAlert} /> }
      <View {...view} />
    </LocaleContext.Provider>
  );
};

const mapStateToProps = state => {
  return {
    view: state.view.view,
    modalOpen: state.modal.showing,
    alert: state.view.alert
  };
};

export default connect(mapStateToProps, { clearView, 
  setView, hideAlert })(ViewContainer);

const updateLocale = locale => {
  if (locale && LS.getLanguage() !== locale) {
    console.log('updating locale: ' + locale);
    LS.setLanguage(locale);
  }
};